import Attribute from 'types/Attribute';
import compact from 'utils/compact';

const getSerializedAttributes = (attributes: Attribute[], noneValueLabel: string) =>
  attributes
    .map(({ name, value }) => `${name}: ${(compact(value).length ? value : [noneValueLabel]).join(', ')}`)
    .join('\n');

export default getSerializedAttributes;
